import {deleteJson, getJson, postJson, patchJson} from '@/util/ajaxUtils';

export function sendBatchJourneies() {
    return getJson(`/open/sendBatchJourneies`);
}

export function sendJourneies(keywords) {
    return getJson(`/open/sendJourneies/${keywords}`);
}
